
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4ccbbb3e&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./StockAlertThresholdsPanel.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./StockAlertThresholdsPanel.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-4ccbbb3e!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./StockAlertThresholdsPanel.vue"),
  /* scopeId */
  "data-v-4ccbbb3e",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/stock/StockAlertThresholdsPanel.vue
// module id = 709
// module chunks = 2